import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AVMRental } from '../../models/response-avm-rental';

@Component({
  selector: 'app-response-avm-rental',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './response-avm-rental.component.html'
})
export class ResponseAvmRentalComponent {

  @Input() response:AVMRental;
}
